<template>
  <div v-if="pages.length || accounts.length || stores.length">
    <b-dropdown
      id="branches-dropdown"
      ref="dropdown"
      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
      v-bind="$props"
      :text="currentModelName"
      class="branches-dropdown"
    >
      <template v-if="pages.length">

        <b-dropdown-group
          id="dropdown-group-1"
          :header="$t('page.face-pages')"
        >
          <template v-for="page in pages">
            <b-dropdown-item-button
              :key="'fb'+page.id"
              button-class="w-100"
              :active="isFacebook && currentModelId === page.id"
              @click="setPage(page.id)"
            >
              {{ page.name }}
            </b-dropdown-item-button>
          </template>
        </b-dropdown-group>
      </template>
      <template v-if="showInstagram && accounts.length">
        <b-dropdown-group
          id="dropdown-group-2"
          :header="$t('instagram.accounts')"
        >
          <template v-for="account in accounts">
            <b-dropdown-item-button
              :key="'insta'+account.id"
              button-class="w-100"
              :active="isInstagram && currentModelId === account.account_id"
              @click="setAccount(account.id)"
            >
              {{ account.name }}
            </b-dropdown-item-button>
          </template>
        </b-dropdown-group>
      </template>
      <!--<template v-if="stores.length">
        <b-dropdown-group
          id="dropdown-group-3"
          :header="$t('store.stores')"
        >
          <template v-for="store in stores">
            <b-dropdown-item-button
              :key="'store'+store.id"
              button-class="w-100"
              :active="isStore && currentModelId === store.id"
              @click="setStore(store.id)"
            >
              {{ store.name }}
            </b-dropdown-item-button>
          </template>
        </b-dropdown-group>
      </template>-->
      <b-dropdown-divider v-if="pages.length || accounts.length" />
      <b-dropdown-item-button
        id="add-branch-dropdown-option"
        button-class="w-100"
        @click="authFacebook(false)"
      >
        {{ $t('page.add-new-page') }}
      </b-dropdown-item-button>
      <b-dropdown-item-button
        v-if="showInstagram"
        id="add-branch-dropdown-option"
        button-class="w-100"
        @click="authInstagram(false)"
      >
        {{ $t('instagram.add-new-account') }}
      </b-dropdown-item-button>
      <b-dropdown-item-button
        v-if="showInstagram"
        id="add-branch-dropdown-option"
        button-class="w-100"
        @click="authInstagramDirect(false)"
      >
        {{ $t('instagram.add-new-account-directly') }}
      </b-dropdown-item-button>
    </b-dropdown>

  </div>
</template>

<script>
import {
  BDropdownGroup, BDropdownItemButton, BDropdown, BDropdownDivider,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import AuthMixin from '@/views/auth/mixins/auth-mixin'

export default {
  name: 'PagesDropdown',
  components: {
    BDropdown,
    BDropdownItemButton,
    BDropdownGroup,
    BDropdownDivider,
  },
  directives: { Ripple },
  mixins: [AuthMixin],
  props: {
    block: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'outline-secondary',
    },

  },
  computed: {
    ...mapGetters({
      pages: 'pages/pages',
      accounts: 'instagram/accounts',
      stores: 'shop/stores',
      currentPage: 'pages/currentPage',
      currentInsta: 'instagram/currentAccount',
      currentStore: 'shop/currentStore',
      isFacebook: 'auth/isFacebook',
      isInstagram: 'auth/isInstagram',
      isStore: 'auth/isStore',
      showInstagram: 'auth/showInstagram',
    }),
    currentModelName() {
      if (this.isFacebook) {
        return this.currentPage.name
      } if (this.isInstagram) {
        return this.currentInsta.name
      } if (this.isStore) {
        return this.currentStore.name
      }
      return null
    },
    currentModelId() {
      if (this.isFacebook) {
        return this.currentPage.id
      } if (this.isInstagram) {
        return this.currentInsta.account_id
      } if (this.isStore) {
        return this.currentStore.id
      }
      return null
    },
  },
  methods: {
    setPage(pageId) {
      this.$store.dispatch('pages/SET_PAGE', pageId)
      this.$store.commit('auth/SET_MODEL_TYPE', 'fb')
      this.$router.push({ name: 'owner:home' })
    },
    setAccount(accountId) {
      this.$store.dispatch('instagram/SET_ACCOUNT', accountId)
      this.$store.commit('auth/SET_MODEL_TYPE', 'instagram')
      this.$router.push({ name: 'owner:home' })
    },
    setStore(accountId) {
      this.$store.dispatch('shop/SET_STORE', accountId)
      this.$store.commit('auth/SET_MODEL_TYPE', 'store')
      this.$router.push({ name: 'owner:home' })
    },
  },
}
</script>

 <style lang="scss">
 #branches-dropdown {
   .dropdown-menu {
     overflow: auto;
     max-height: 25rem;
   }
   .dropdown-header{
     color: black;
     font-weight: 600;
   }
 }
 </style>
